<div class="notification-body">
    <mat-icon *ngIf="data.type === 'success'" class="notification-icon">check_circle</mat-icon>
    <mat-icon *ngIf="data.type === 'error'" class="notification-icon">error</mat-icon>
    <span class="notification-text">{{ data.message }}</span>
</div>